import * as actionTypes from '../actionTypes/address';

export function getLocationData() {
    return { type: actionTypes.LOCATION_DATA_LOAD };
}

export function getUserAddress(hideLoader) {
    return { type: actionTypes.USER_ADDRESS_LOAD, hideLoader };
}
export function getPincodeData(pincode) {
    return { type: actionTypes.PINCODE_DATA_LOAD, pincode };
}

export function updateUserAddress(addressJson, addressId = null, pageName = null) {
    return { type: actionTypes.UPDATE_USER_ADDRESS_LOAD, addressJson, addressId, pageName };
}

export function deleteUserAddress(addressId) {
    return { type: actionTypes.DELETE_USER_ADDRESS_LOAD, addressId };
}

export function clearState(data) {
    return { type: actionTypes.CLEAR_STATE, data };
}
